import React, { useState, useEffect, useMemo } from 'react';
import {
  Container, Box, Typography, Paper, TextField, Button, Alert, Chip, Tabs, Tab,
} from '@mui/material';
import axios from 'axios';
import SidebarLayout from '../components/SidebarLayout';

const parseLines = (text: string) =>
  text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);

type TextType = 'barrage' | 'comment';

const CopyTextManagement = () => {
  const [tab, setTab] = useState<TextType>('barrage');
  const [text, setText] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const lineCount = useMemo(() => parseLines(text).length, [text]);

  const fetchItems = async (type: TextType) => {
    const resp = await axios.get('/api/bili/copy-texts/all', { params: { type } });
    if (resp.data.success) {
      const lines = (resp.data.items || []).map((r: { content: string }) => r.content);
      setText(lines.join('\n'));
    }
  };

  useEffect(() => { fetchItems(tab).catch(console.error); }, [tab]);

  const handleSave = async () => {
    const lines = parseLines(text);
    if (lines.length === 0) {
      setMsg('请至少填写一条文案（每行一条）');
      setTimeout(() => setMsg(''), 4000);
      return;
    }
    setLoading(true);
    try {
      const items = lines.map((content, i) => ({ content, enabled: true, sort_order: i }));
      await axios.put('/api/bili/copy-texts', { type: tab, items });
      setMsg(`已保存 ${lines.length} 条${tab === 'barrage' ? '弹幕' : '评论'}文案`);
      fetchItems(tab);
    } catch (e: any) {
      setMsg(e.response?.data?.message || '保存失败');
    } finally {
      setLoading(false);
      setTimeout(() => setMsg(''), 4000);
    }
  };

  return (
    <SidebarLayout>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>文案管理（后台锁死）</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          每行一条。总控模式从云端拉取；手动模式仍可在插件本地编辑。
        </Typography>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
          <Tab label="弹幕文案" value="barrage" />
          <Tab label="评论文案" value="comment" />
        </Tabs>
        {msg && <Alert severity={msg.includes('失败') || msg.includes('至少') ? 'error' : 'success'} sx={{ mb: 2 }}>{msg}</Alert>}
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
            <Typography variant="subtitle2">{tab === 'barrage' ? '弹幕' : '评论'}文案</Typography>
            <Chip label={`共 ${lineCount} 条`} size="small" color={lineCount > 0 ? 'primary' : 'default'} variant="outlined" />
          </Box>
          <TextField
            fullWidth multiline minRows={12} maxRows={24}
            placeholder={tab === 'barrage' ? '好看！\n支持！\n太棒了' : '写得真好\n支持一波\n收藏了'}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, mb: 2 }}>
            空行忽略；保存后覆盖该类型全部文案。
          </Typography>
          <Button variant="contained" onClick={handleSave} disabled={loading}>保存</Button>
        </Paper>
      </Container>
    </SidebarLayout>
  );
};

export default CopyTextManagement;
